import './tab.less';
import Utils from '@packages/utils/utils.js';
import Transition from '@packages/utils/transition.js';
import EventBus from '@packages/utils/eventBus.js';
import Extends from '@packages/utils/extends.js';

var touchEvents = {
  start: Utils.support.touch ? 'touchstart' : 'mousedown',
  move: Utils.support.touch ? 'touchmove' : 'mousemove',
  end: Utils.support.touch ? 'touchend' : 'mouseup'
};
var startTime = 0;
var endTime = 0;
var duration = 0;
var isTouchEvent = false;
var isTouch = false;
var isSliding;
var Tab = function (el, options) {
  this.wrapper = typeof el === 'string' ? document.querySelector(el) : el;
  this.contents = this.wrapper.querySelector('.bx-tab-contents');
  this.scroller = this.wrapper.querySelector('.bx-tab-scroller');
  this.line = null;
  var defaults = {
    width: null,
    lineWidth: 22,
    scale: null,
    slide: true,
    transition: true,
    transitionSpeed: 300,
    bounce: true,
    angle: 45,
    activeIndex: 0,
    onInit: Utils.noop(),
    onSlidePrev: Utils.noop,
    onSlideNext: Utils.noop,
    onChange: Utils.noop(),
    onTabClick: Utils.noop()
  }
  this.options = defaults;
  Extends(this.options, options);
  this.options.$parent = this;
  this.total = 0;
  this.currentIndex = this.options.activeIndex || 0;
  this.direction = null;
  this.offset = {
    x: 0,  // 横向滑动距离
    y: 0   // 纵向滑动距离
  };
  this.touches = {
    startX: 0,  // touch前一个点
    startY: 0,  // touch前一个点
    currentX: 0, // touch后一个点
    currentY: 0, // touch后一个点
    distanceX: 0, // 两个touch之间的距离
    distanceY: 0  // 两个touch之间的距离
  };
  this.distance = 0;
  this.singleContent = false;
  this.unique = this.options.unique || Utils.getUnique();
  this.init();
};
Tab.prototype = {
  init: function () {
    var self = this;
    self.setWidth();
    self.setScale();
    self.setSlide();
    self.total = self.getTotal();
    self.observer = EventBus.create(self.unique);
    self.line = new Line(self.wrapper.querySelector('.bx-tab-line'), {
      unique: self.unique,
      total: self.total,
      width: self.options.lineWidth,
      containerWidth: self.computedWidth
    });
    self.line.setParent(self);
    self._addEvent();
    self.goToIndex(self.currentIndex, 0);
    self.observer.emit('onInit');
  },
  // 设置容器宽度
  setWidth: function () {
    var self = this;
    var _width = 0;
    if (self.options.width) {
      self.wrapper.style.width = Utils.isPercentage(self.options.width) ? self.options.width : self.options.width + 'px';
    }
    _width = self.wrapper.clientWidth;
    self.computedWidth = _width;
  },
  // 设置元素放大倍数
  setScale: function () {
    var self = this;
    if (!self.options.scale) {
      self.options.scale = Utils.getScale();
    }
    this.wrapper.querySelector('.bx-tab-wrap').style['zoom'] = self.options.scale;
  },
  getTotal: function () {
    var self = this;
    var items = self.wrapper.querySelectorAll('.bx-tab-item');
    return items.length;
  },
  setSlide: function () {
    var self = this;
    var items = self.wrapper.querySelectorAll('.bx-tab-content');
    if (items.length <= 1) {
      self.options.slide = false;
      self.options.transition = false;
      self.singleContent = true;
    }
  },
  slideTo: function (x, y, time) {
    var self = this;
    Transition.setProperty(self.scroller, Transition.prefixStyle('transform'));
    time !== 0 && (time = self.options.transitionSpeed);
    self.options.slide || self.options.transition || (time = 0);
    Transition.setDuration(self.scroller, time);
    self._translate(x, y);
  },
  slideToIndex: function (index) {
    var self = this;
    self.slideTo(-1 * index * self.computedWidth, 0);
    self.setContentActive();
  },
  clickToIndex: function (index) {
    var self = this;
    self.goToIndex(index);
  },
  goToIndex: function (index, time) {
    var self = this;
    self.setTabActive();
    self.setContentActive();
    self.singleContent ? self.slideTo(0, 0, 0) : self.slideTo(-1 * index * self.computedWidth, 0, time);
    self.line.clickToIndex(index, time);
  },
  setTabActive: function () {
    var self = this;
    var items = self.wrapper.querySelectorAll('.bx-tab-item');
    for (var index = 0; index < items.length; index++) {
      if (index === self.currentIndex) {
        !Utils.hasClass(items[index], 'bx-tab--active') && Utils.addClass(items[index], 'bx-tab--active');
      } else {
        Utils.hasClass(items[index], 'bx-tab--active') && Utils.removeClass(items[index], 'bx-tab--active');
      }
    }
    self.observer.emit('onChange', self.currentIndex);
  },
  setContentActive: function () {
    var self = this;
    var items = self.wrapper.querySelectorAll('.bx-tab-content');
    if (self.singleContent) {
      !Utils.hasClass(items[0], 'bx-tab-content--active') && Utils.addClass(items[0], 'bx-tab-content--active')
    } else {
      for (var index = 0; index < items.length; index++) {
        if (index === self.currentIndex) {
          !Utils.hasClass(items[index], 'bx-tab-content--active') && Utils.addClass(items[index], 'bx-tab-content--active')
        } else {
          Utils.hasClass(items[index], 'bx-tab-content--active') && Utils.removeClass(items[index], 'bx-tab-content--active')
        }
      }
    }
  },
  prev: function () {
    var self = this;
    self.currentIndex--;
    if (self.currentIndex < 0) {
      self.currentIndex = 0;
    }
    self.observer.emit('onSlidePrev');
    self.slideToIndex(self.currentIndex);
    self.line.slideToIndex(self.currentIndex);
  },
  next: function () {
    var self = this;
    self.currentIndex++;
    if (self.currentIndex >= self.total) {
      self.currentIndex = self.total - 1;
    }
    self.observer.emit('onSlideNext');
    self.slideToIndex(self.currentIndex);
    self.line.slideToIndex(self.currentIndex);
  },
  handleEvent: function (e) {
    switch (e.type) {
      case 'click':
        this._onItemClick(e);
        break;
      case 'touchstart':
        this._onTouchStart(e);
        break;
      case 'touchmove':
        this._onTouchMove(e);
        break;
      case 'touchend':
        this._onTouchEnd(e);
        break;
      case 'mousedown':
        this._onTouchStart(e);
        break;
      case 'mousemove':
        this._onTouchMove(e);
        break;
      case 'mouseup':
        this._onTouchEnd(e);
        break;
      case 'transitionend':
        this._transitionEnd(e);
        break;
      case 'webkitTransitionEnd':
        this._transitionEnd(e);
        break;
      case 'resize':
        this._onResize(e);
        break;
    }
  },
  // 判断是否需要回弹
  setBounce: function () {
    var self = this;
    if (self.currentIndex === 0 && self.direction === 'right' && self.offset.x > 0) {
      return true;
    }
    if (self.currentIndex === (self.total - 1) && self.direction === 'left' && Math.abs(self.offset.x) > (self.total - 1) * self.computedWidth) {
      return true;
    }
    return false;
  },
  _addEvent: function () {
    var self = this;
    if (self.options.slide) {
      self.contents['addEventListener'](touchEvents.start, this, false);
      self.contents['addEventListener'](touchEvents.move, this, false);
      self.contents['addEventListener'](touchEvents.end, this, false);
      self.scroller['addEventListener']('transitionend', this, false);
      self.scroller['addEventListener']('webkitTransitionEnd', this, false);
    }
    window['addEventListener']('resize', this, false);
    self._addClick();
    self.observer.on('setTabActive', function () {
      self.setTabActive();
    });
    for (var item in self.options) {
      if (item.indexOf('on') === 0) {
        if (self.options[item] instanceof Function) {
          (function (item, _self) {
            _self.observer.on(item, function () {
              _self.options[item].apply(_self, Array.prototype.slice.call(arguments));
            });
          })(item, self)
        }
      }
    }
  },
  _addClick: function () {
    var self = this;
    var items = self.wrapper.querySelectorAll('.bx-tab-item');
    for (var i = 0; i < items.length; i++) {
      (function (index) {
        items[index]['addEventListener']('click', function (e) {
          self._onItemClick(e, index);
        }, false);
      })(i);
    }
  },
  _onItemClick: function (e, index) {
    var self = this;
    self.currentIndex = index;
    self.observer.emit('onItemClick', index);
    self.clickToIndex(index);
  },
  _onTouchStart: function (e) {
    var self = this;
    // 兼容jq自己封装的originalEvent,指向原始的事件对象
    if (e.originalEvent) e = e.originalEvent;
    // 大于一个touch点,不做处理
    if (e.touches && e.touches.length > 1) {
      e.preventDefault();
      return;
    }
    isTouchEvent = (e.type === 'touchstart');
    isTouch = true;
    isSliding = undefined;
    self.touches.startX = (isTouchEvent ? e.touches[0].clientX : e.clientX);
    self.touches.startY = (isTouchEvent ? e.touches[0].clientY : e.clientY);
    startTime = Utils.now();
    self.distance = 0;
    self.line.touchStart();
    Transition.setDuration(self.scroller, 0);
  },
  _onTouchMove: function (e) {
    var self = this;
    if (e.originalEvent) e = e.originalEvent;
    if (!isTouch && e.type === 'mousemove') {
      e.preventDefault();
      return;
    }
    if (e.touches && e.touches.length > 1) {
      e.preventDefault();
      return;
    }
    self.touches.currentX = (e.type === 'touchmove' ? e.touches[0].clientX : e.clientX);
    self.touches.currentY = (e.type === 'touchmove' ? e.touches[0].clientY : e.clientY);
    var touchAngle = Math.atan2(Math.abs(self.touches.currentY - self.touches.startY), Math.abs(self.touches.currentX - self.touches.startX)) * 180 / Math.PI;
    if (typeof isSliding === 'undefined') {
      isSliding = (touchAngle <= self.options.angle);
    }
    if (!isSliding) {
      return;
    }
    self.touches.distanceX = self.touches.currentX - self.touches.startX;
    self.touches.distanceX > 0 ? self.direction = 'right' : self.direction = 'left';
    self.options.bounce && (self.bounce = self.setBounce());
    self.bounce && (self.touches.distanceX = self.touches.distanceX / 2);
    self.offset.x += self.touches.distanceX;
    self.distance += self.touches.distanceX;
    self._translate(self.offset.x, 0);
    self.line.touchMove(self.touches.distanceX, self.distance);

    self.touches.startX = self.touches.currentX;
    self.touches.startY = self.touches.currentY;

    e.preventDefault();
  },
  _onTouchEnd: function (e) {
    var self = this;
    endTime = Utils.now();
    duration = endTime - startTime;
    if (!self.bounce && ((duration <= 300 && Math.abs(self.distance) > 30) || Math.abs(self.distance) > self.computedWidth / 2)) {
      self.distance > 0 ? self.prev() : self.next();
    } else {
      self.slideTo(self.offset.x - self.distance, 0);
      self.line.stretchTo(self.line.options.width);
    }
    isTouch = false;
  },
  _onResize: function (e) {
    var self = this;
    self.setWidth();
    self.slideTo(-1 * self.currentIndex * self.computedWidth, 0, 0);
    self.line.options.containerWidth = self.computedWidth;
    self.line._onResize(e);
  },
  // transition动画结束后回调
  _transitionEnd: function (e) {
  },
  // 页面滑动到指定位置
  _translate: function (x, y) {
    var self = this;
    if (!self.options.bounce) {
      if (x > 0) {
        x = 0;
      }
      var totalDistance = (self.total - 1) * self.computedWidth;
      if (Math.abs(x) > totalDistance) {
        x = -1 * totalDistance;
      }
    }
    self.offset.x = x;
    Transition.setTransform(self.scroller, x, y);
  }
}

var Line = function (el, options) {
  this.el = typeof el === 'string' ? document.querySelector(el) : el;
  this.options = {
    width: 22,
    speed: 200,
    total: 1,
    containerWidth: null
  };
  Extends(this.options, options);
  this.unique = this.options.unique || Utils.getUnique();
  this.init();
}
Line.prototype = {
  parent: null,
  currentIndex: 0,
  direction: null,
  distance: 0,
  isTransition: false,
  positionType: 'left',
  init: function () {
    var self = this;
    self.setScale();
    self.setWidth();
    self.setPosition();
    self.observer = EventBus.create(self.unique);
    self.addEvent();
  },
  setWidth: function () {
    var self = this;
    if (self.options.width) {
      self.el.style.width = self.options.width + 'px';
    }
    self.tabWidth = self.options.containerWidth / self.options.total;
    self.maxWidth = self.tabWidth + self.options.width;
  },
  // 设置元素放大倍数
  setScale: function () {
    var self = this;
    if (!self.options.scale) {
      self.options.scale = Utils.getScale();
    }
    self.options.width = self.options.scale * self.options.width;
    self.el.style['height'] = self.el.clientHeight * self.options.scale + 'px';
  },
  setParent: function (obj) {
    this.parent = obj;
  },
  setDirection: function (distance) {
    var self = this;
    self.direction = distance < 0 ? 'right' : 'left';
  },
  setPosition: function (type, index) {
    var self = this;
    (index === undefined || index === null) && (index = self.currentIndex);
    var tabWidth = self.options.containerWidth / self.options.total;
    var left = (tabWidth - self.options.width) / 2 + index * tabWidth;
    var right = self.options.containerWidth - left - self.options.width;
    self.positionType = type || 'left';
    if (type === 'right') {
      self.el.style['right'] = right + 'px';
      self.el.style['left'] = 'auto';
    } else {
      self.el.style['left'] = left + 'px';
      self.el.style['right'] = 'auto';
    }
  },
  touchStart: function () {
    var self = this;
    self.distance = 0;
  },
  touchMove: function (x) {
    var self = this;
    self.distance += 2 * x / self.options.total;
    self.setDirection(self.distance);
    // 边界判断
    if ((self.currentIndex === 0 && self.direction === 'left') || (self.currentIndex === (self.options.total - 1) && self.direction === 'right')) {
      return;
    }

    var width = 0;
    var index = self.currentIndex;
    var direction = self.direction;
    var distance = Math.abs(self.distance);
    if (distance >= self.tabWidth) {
      distance >= 2 * self.tabWidth && (distance = 2 * self.tabWidth);
      width = self.options.width + 2 * self.tabWidth - distance;
      index = self.direction === 'left' ? self.currentIndex - 1 : self.currentIndex + 1;
    } else {
      width = self.options.width + distance;
      direction = self.direction === 'left' ? 'right' : 'left';
    }
    self.setPosition(direction, index);
    self.stretchTo(width, 0);
  },
  stretchTo: function (width, time) {
    var self = this;
    Transition.setProperty(self.el, 'width');
    time !== 0 && time === undefined && (time = self.options.speed);
    Transition.setDuration(self.el, time);
    // 强制开启硬件加速
    Transition.setTransform(self.el, 0, 0);
    self.el.style.width = width + 'px';
  },
  moveTo: function (index, time) {
    var self = this;
    Transition.setProperty(self.el, self.positionType);
    time !== 0 && time === undefined && (time = self.options.speed);
    Transition.setDuration(self.el, time);
    self.currentIndex = index;
    self.setPosition(self.positionType);
  },
  slideToIndex: function (index) {
    var self = this;
    if ((self.currentIndex === 0 && self.direction === 'left') || (self.currentIndex === (self.options.total - 1) && self.direction === 'right')) {
      return;
    }
    self.currentIndex = index;
    var width = self.options.width;
    if (Math.abs(self.distance) < self.tabWidth) {
      self.isTransition = true;
      width = self.maxWidth;
    }
    self.stretchTo(width);
    self.observer.emit('setTabActive');
  },
  clickToIndex: function (index, time) {
    var self = this;
    self.moveTo(index, time);
  },
  prev: function () {
    var self = this;
    self.currentIndex--;
    if (self.currentIndex < 0) {
      self.currentIndex = 0;
    }
    self.slideToIndex(self.currentIndex);
  },
  next: function () {
    var self = this;
    self.currentIndex++;
    if (self.currentIndex >= self.options.total) {
      self.currentIndex = self.options.total - 1;
    }
    self.slideToIndex(self.currentIndex);
  },
  addEvent: function () {
    var self = this;
    self.el['addEventListener']('transitionend', this, false);
    self.el['addEventListener']('webkitTransitionEnd', this, false);
  },
  handleEvent: function (e) {
    var self = this;
    switch (e.type) {
      case 'transitionend':
        self._transitionEnd(e);
        break;
      case 'webkitTransitionEnd':
        self._transitionEnd(e);
        break;
    }
  },
  _onResize: function (e) {
    var self = this;
    self.setWidth();
    self.setPosition();
  },
  _transitionEnd: function (e) {
    var self = this;
    if (self.isTransition) {
      self.setPosition(self.direction);
      self.stretchTo(self.options.width, self.options.speed);
      self.isTransition = false;
    }
  }
};
export default Tab;



// WEBPACK FOOTER //
// ./packages/components/tab/tab.js